import getSerialId from './getSerialId';

export default function getDefaultData({
	language = 'en',
	locale,
	profile,
	includeSerialId = true,
} = {}) {
	return {
		aem_url: '',
		page_language: language,
		// PART OF AVAILABILITY CHECK - The availability check event should be triggered only once for an availability check. There are two methods that could accomplish this: first, server-side logic could be used to suppress this event on reloads of the “Choose Room” page; or second, a technique called Event Serialization could be used.
		// For this purpose, each unique serial should reflect a unique availability check— in other words, if someone does an availability check and is assigned a serial of 12345, that same serial should be sent through on any page reloads so Adobe can de-duplicate the reload.
		...(includeSerialId ? { serial_id: getSerialId() } : {}),
		site_prefix: 'fs',
		site_template: 'shopping cart',
		user_id: profile?.uniqueId,
		golden_id: profile?.goldenId ?? 'na',
		user_type: profile ? 'member' : 'visitor',
		ja_cookie: undefined,
	};
}
